import {
    GET_LEAD_PROFILE_PHOTOS_REQUEST,
    GET_LEAD_PROFILE_PHOTOS_REQUEST_SUCCESS,
    GET_LEAD_PROFILE_PHOTOS_REQUEST_FAILURE,
    UPLOAD_LEAD_PROFILE_PHOTO_REQUEST,
    UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS,
    UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_FAILURE,
    DELETE_LEAD_PROFILE_PHOTO_REQUEST,
    DELETE_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS, DELETE_LEAD_PROFILE_PHOTO_REQUEST_FAILURE,
} from '../constants/lead_profile_photos.constants';

const initialState = {
    loading: false,
    photos: [],
    error: null,
};

export const Lead_photos = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_LEAD_PROFILE_PHOTOS':
        return {
            ...state,
            ...action.payload,
        };
    case GET_LEAD_PROFILE_PHOTOS_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_LEAD_PROFILE_PHOTOS_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            photos: action.payload,
        };
    case GET_LEAD_PROFILE_PHOTOS_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case UPLOAD_LEAD_PROFILE_PHOTO_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            photos: [...state.photos, action.payload],
        };
    case UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case DELETE_LEAD_PROFILE_PHOTO_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case DELETE_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            photos: [...state.photos, action.payload],
        };
    case DELETE_LEAD_PROFILE_PHOTO_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_profile_photos.reducers.js